import qs from 'qs'

export const stringify = (obj: object) => qs.stringify(obj, { encode: false })

export const parse = (str: string) => qs.parse(str)
